import API from '../config/api';
import React, { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';

import { Card, Form, Button, Spinner } from 'react-bootstrap';

import CustomNavbar from '../components/CustomNavbar';
import AuthBackground from '../components/AuthBackground';

function ForgotPasswordPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const sendOtp = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.warning('Please enter your email');
      return;
    }

    try {
      setLoading(true);

      await axios.post(`${API}/users/forgot-password`, {
        email
      });

      localStorage.setItem('resetEmail', email);

      toast.success('OTP sent to your email');

      navigate('/verify-otp');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomNavbar />

      <div className="auth-wrap">
        <AuthBackground />

        <Card className="border-0 shadow-lg auth-card auth-card-glass">
          <Card.Body className="p-4 p-md-5">
            <div className="text-center mb-4">
              <div className="auth-icon">🔑</div>

              <h3 className="fw-bold mb-2">Forgot Password?</h3>

              <p className="text-muted mb-0">
                No worries! Enter your registered email and we'll send you a
                one-time code to reset your password.
              </p>
            </div>

            <Form onSubmit={sendOtp}>
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Email Address</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">✉️</span>

                  <Form.Control
                    type="email"
                    placeholder="you@example.com"
                    className="auth-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
                  />
                </div>
              </Form.Group>

              <Button
                type="submit"
                className="w-100 fw-bold auth-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Sending...
                  </>
                ) : (
                  'Send OTP'
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <Link to="/login" className="auth-link">
                ← Back to Login
              </Link>
            </div>
          </Card.Body>
        </Card>
      </div>

      <style>{authStyles}</style>
    </>
  );
}

export const authStyles = `
  .auth-wrap {
    position: relative;
    overflow: hidden;
    min-height: calc(100vh - 70px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: clamp(20px, 5vw, 50px) 16px;
    background: radial-gradient(720px 320px at 8% -5%, rgba(124,58,237,0.12), transparent 70%), radial-gradient(720px 320px at 92% 105%, rgba(234,88,12,0.14), transparent 70%), linear-gradient(180deg, #faf5ff 0%, #fff7ed 55%, #fef3c7 100%);
  }

  .auth-card {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 460px;
    border-radius: 24px;
    background: #ffffff;
  }
  .auth-card-wide {
    max-width: 620px;
  }

  /* Glassmorphism variant — lets the animated backdrop show through */
  .auth-card-glass {
    background: rgba(255, 255, 255, 0.55) !important;
    backdrop-filter: blur(16px) saturate(140%);
    -webkit-backdrop-filter: blur(16px) saturate(140%);
    border: 1px solid rgba(255, 255, 255, 0.6) !important;
    box-shadow: 0 20px 50px rgba(124, 45, 18, 0.18) !important;
  }
  .auth-card-glass .text-muted {
    color: #6b4a3a !important;
  }
  .auth-card-glass .auth-input {
    background: rgba(255, 255, 255, 0.7) !important;
  }

  .auth-icon {
    width: 74px;
    height: 74px;
    margin: 0 auto 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    border-radius: 50%;
    background: linear-gradient(135deg, #c2410c, #ea580c);
    box-shadow: 0 10px 24px rgba(234, 88, 12, 0.35);
  }

  .auth-input-group {
    position: relative;
  }
  .auth-input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1rem;
    opacity: 0.8;
    pointer-events: none;
  }
  .auth-input {
    border-radius: 14px !important;
    padding: 12px 14px 12px 42px !important;
    border: 1px solid #e5e7eb !important;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  .auth-input:focus {
    border-color: #ea580c !important;
    box-shadow: 0 0 0 0.2rem rgba(234, 88, 12, 0.15) !important;
  }

  .auth-btn {
    border: none !important;
    border-radius: 14px !important;
    padding: 12px !important;
    font-size: 1rem;
    background: linear-gradient(135deg, #c2410c, #ea580c) !important;
    box-shadow: 0 10px 22px rgba(194, 65, 12, 0.3);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .auth-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(194, 65, 12, 0.4);
  }
  .auth-btn:disabled {
    opacity: 0.8;
  }

  .auth-link {
    color: #ea580c;
    font-weight: 600;
    text-decoration: none;
  }
  .auth-link:hover {
    text-decoration: underline;
  }

  /* "or" divider */
  .auth-divider {
    display: flex;
    align-items: center;
    text-align: center;
    color: #9ca3af;
    font-size: 0.85rem;
    margin: 20px 0 16px;
  }
  .auth-divider::before,
  .auth-divider::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e5e7eb;
  }
  .auth-divider span {
    padding: 0 12px;
  }

  /* Delivery partner call-to-action link */
  .auth-partner-link {
    text-decoration: none;
    color: #7c2d12;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    border-radius: 14px;
    padding: 12px;
    transition: background 0.2s ease, transform 0.2s ease;
  }
  .auth-partner-link:hover {
    background: #ffedd5;
    transform: translateY(-2px);
    color: #7c2d12;
  }

  /* Show/hide password toggle */
  .auth-eye {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 0;
    line-height: 1;
  }

  /* Password strength meter */
  .auth-strength-track {
    height: 6px;
    border-radius: 6px;
    background: #e5e7eb;
    overflow: hidden;
    margin-bottom: 4px;
  }
  .auth-strength-fill {
    height: 100%;
    border-radius: 6px;
    transition: width 0.3s ease, background 0.3s ease;
  }

  /* OTP segmented input */
  .otp-inputs {
    display: flex;
    gap: clamp(6px, 2.5vw, 12px);
    justify-content: center;
    margin: 8px 0 4px;
  }
  .otp-box {
    width: clamp(42px, 13vw, 56px);
    height: clamp(50px, 15vw, 64px);
    text-align: center;
    font-size: clamp(1.2rem, 5vw, 1.6rem);
    font-weight: 700;
    border-radius: 14px;
    border: 2px solid #e5e7eb;
    background: #f9fafb;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }
  .otp-box:focus {
    outline: none;
    background: #ffffff;
    border-color: #ea580c;
    box-shadow: 0 0 0 0.2rem rgba(234, 88, 12, 0.15);
  }
`;

/*
  Opt-in dark "sanctum" skin for an auth card. Everything is scoped under
  .auth-divine, so a page only gets it by adding that class and rendering
  this block after authStyles.
*/
export const divineAuthStyles = `
  /* Sanctum palette: lamp-black → temple maroon → saffron */
  .auth-divine {
    position: relative;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(26, 6, 17, 0.93) 0%, rgba(70, 13, 22, 0.9) 52%, rgba(124, 45, 18, 0.88) 100%) !important;
    border: 1px solid rgba(253, 230, 138, 0.35) !important;
    box-shadow: 0 26px 60px rgba(20, 6, 2, 0.5) !important;
    color: #fff7ed;
  }
  /* Gold rule tracing the inside of the card */
  .auth-divine::after {
    content: '';
    position: absolute;
    inset: 9px;
    border: 1px solid rgba(253, 230, 138, 0.22);
    border-radius: 17px;
    pointer-events: none;
  }

  .auth-divine .ad-om {
    position: absolute;
    right: -14px;
    bottom: -40px;
    font-size: 11rem;
    line-height: 1;
    font-weight: 700;
    color: rgba(253, 230, 138, 0.07);
    pointer-events: none;
  }

  /* Lamps at the top corners, each with a live flame */
  .auth-divine .ad-lamp {
    position: absolute;
    top: 14px;
    font-size: 1.15rem;
    line-height: 1;
    z-index: 2;
    pointer-events: none;
    filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.4));
  }
  .auth-divine .ad-lamp-left  { left: 20px; }
  .auth-divine .ad-lamp-right { right: 20px; }
  .auth-divine .ad-flame {
    position: absolute;
    left: 50%;
    top: -9px;
    width: 6px; height: 12px;
    margin-left: -3px;
    border-radius: 50% 50% 50% 50% / 62% 62% 38% 38%;
    background: radial-gradient(circle at 50% 72%, #fffbeb 0%, #fde68a 30%, #fbbf24 56%, rgba(249,115,22,0.9) 78%, rgba(249,115,22,0) 100%);
    box-shadow: 0 0 16px rgba(251, 191, 36, 0.9);
    transform-origin: 50% 100%;
    animation: adFlame 1.05s ease-in-out infinite;
  }
  .auth-divine .ad-lamp-right .ad-flame {
    animation-duration: 0.87s;
    animation-delay: -0.4s;
  }
  @keyframes adFlame {
    0%, 100% { transform: scale(1, 1)       rotate(-2deg); opacity: 0.92; }
    22%      { transform: scale(0.86, 1.22) rotate(4deg);  opacity: 1; }
    47%      { transform: scale(1.12, 0.9)  rotate(-5deg); opacity: 0.8; }
    71%      { transform: scale(0.94, 1.1)  rotate(3deg);  opacity: 1; }
  }

  /* Type */
  .auth-divine .ad-title {
    color: #fde68a;
    text-shadow: 0 3px 14px rgba(0, 0, 0, 0.45);
  }
  .auth-divine .text-muted { color: rgba(245, 230, 200, 0.7) !important; }
  .auth-divine .form-label { color: rgba(253, 230, 138, 0.9); }

  /* Medallion with a warm halo */
  .auth-divine .auth-icon {
    background: linear-gradient(135deg, #7c2d12, #b45309 55%, #f59e0b) !important;
    border: 1px solid rgba(253, 230, 138, 0.6);
    box-shadow: 0 0 0 6px rgba(251, 191, 36, 0.1), 0 12px 28px rgba(180, 83, 9, 0.5);
    animation: adHalo 4s ease-in-out infinite;
  }
  @keyframes adHalo {
    0%, 100% { box-shadow: 0 0 0 6px rgba(251,191,36,0.08), 0 12px 28px rgba(180,83,9,0.45); }
    50%      { box-shadow: 0 0 0 12px rgba(251,191,36,0.16), 0 12px 34px rgba(251,191,36,0.6); }
  }

  /* Fields */
  .auth-divine .auth-input,
  .auth-divine.auth-card-glass .auth-input {
    background: rgba(255, 255, 255, 0.07) !important;
    border: 1px solid rgba(253, 230, 138, 0.3) !important;
    color: #fff7ed !important;
  }
  .auth-divine .auth-input::placeholder { color: rgba(245, 230, 200, 0.45); }
  .auth-divine .auth-input:focus {
    background: rgba(255, 255, 255, 0.12) !important;
    border-color: #fbbf24 !important;
    box-shadow: 0 0 0 0.2rem rgba(251, 191, 36, 0.2) !important;
  }
  .auth-divine .auth-eye { color: #fde68a; }
  .auth-divine .auth-strength-track { background: rgba(255, 255, 255, 0.14); }

  /* Actions */
  .auth-divine .auth-btn {
    background: linear-gradient(135deg, #b45309, #f59e0b 55%, #fbbf24) !important;
    color: #3b1206 !important;
    box-shadow: 0 12px 26px rgba(251, 191, 36, 0.35);
  }
  .auth-divine .auth-btn:hover:not(:disabled) {
    box-shadow: 0 16px 34px rgba(251, 191, 36, 0.55);
  }
  .auth-divine .auth-link { color: #fbbf24; }

  .auth-divine .auth-divider { color: rgba(245, 230, 200, 0.6); }
  .auth-divine .auth-divider::before,
  .auth-divine .auth-divider::after {
    border-bottom: 1px solid rgba(253, 230, 138, 0.25);
  }

  .auth-divine .auth-partner-link {
    color: #fde68a;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(253, 230, 138, 0.3);
  }
  .auth-divine .auth-partner-link:hover {
    background: rgba(253, 230, 138, 0.14);
    color: #fff7ed;
  }

  @media (max-width: 575.98px) {
    .auth-divine .ad-lamp-left  { left: 14px; }
    .auth-divine .ad-lamp-right { right: 14px; }
    .auth-divine .ad-om { font-size: 8.5rem; }
  }

  @media (prefers-reduced-motion: reduce) {
    .auth-divine .ad-flame,
    .auth-divine .auth-icon { animation: none; }
  }
`;

export default ForgotPasswordPage;
